module.exports = __webpack_public_path__ + "media/images/shared/icon_hotel_white-956ccc6df3529512f6c1d59f3d18ba7c.png";